import React from 'react'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'

const Badge = (props: any) => {
  return (
    <div className='d-flex ms-auto'>
      {(props?.badge === 'RR' || props?.badge === 'Both') && props?.badge !== 'Neither' && (
        <span
          aria-label={'Response Requested'}
          className='poppins-semibold font-11 whitetext border-radius3 mx-1 status-label  bgcolor-13'
          tabIndex={0}
        >
          {defaultToEmptyString('RR')}
        </span>
      )}
      {(props?.badge === 'RP' || props?.badge === 'Both') && props?.badge !== 'Neither' && (
        <span
          aria-label={'Response Pending'}
          className='badge poppins-semibold font-11 whitetext border-radius3 mx-1 status-label  bgcolor-53'
          tabIndex={0}
        >
          {defaultToEmptyString('RP')}
        </span>
      )}
      {(props?.badge !== 'RP' &&
        props?.badge !== 'RR' &&
        props?.badge !== 'Neither' &&
        props?.badge !== 'Both' &&  props?.badge) && (
        <span
          aria-label={props?.badge}
          className='badge poppins-semibold font-11 whitetext border-radius3 mx-1 status-label  bgcolor-53'
          tabIndex={0}
        >
          {defaultToEmptyString(props?.badge)}
        </span>
      )}
    </div>
  )
}
export default Badge
